import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useSelector } from "react-redux";
import { RootState } from "redux/reducers";
import { useAppDispatch } from "redux/store";
import {
  resetUser_ContactsToInit,
  setUser_ContactsMessage,
} from "redux/actions";
import { Button, Card, Col, Form, InputGroup } from "react-bootstrap";
import { Constant } from "template/Constant";
import ConfirmationModal from "template/ConfirmationModal";
import { deleteUser_Contacts } from "services/user_contactsService";
import { useUser } from "../../hooks/useUser";

type Props = {
  hideShowForm: (action) => void;
  handleRowEdit: (row) => void;
  getData: (page, pageSize, searchKey) => void;
  action: string;
};

export const User_ContactsTable: React.FC<Props> = ({
  hideShowForm,
  handleRowEdit,
  getData,
  action,
}) => {
  const dispatch = useAppDispatch();
  const [search, setSearch] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [rowData, setRowData] = useState(undefined);
  const rData = useSelector((state: RootState) => state.user_contacts);
  const handleSearch = () => {
    if (search.length > 0) {
      getData(Constant.defaultPageNumber, Constant.defaultPageSize, search);
    }
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    await getData(page, newPerPage, "");
  };
  const handlePageChange = (page) => {
    getData(page, rData.pageSize, "");
  };
  const handleRowDeleteClick = (row) => {
    setRowData(row);
    setShowDelete(true);
  };
  useEffect(() => {
    getData(Constant.defaultPageNumber, Constant.defaultPageSize, "");
  }, [action]);
  const handleReset = () => {
    setSearch("");
    dispatch(resetUser_ContactsToInit());
    getData(Constant.defaultPageNumber, rData.pageSize, "");
  };
  const handleServerDelete = async () => {
    if (rowData) {
      const response = await deleteUser_Contacts(rowData.id);
      if (response) {
        dispatch(resetUser_ContactsToInit());
        dispatch(
          setUser_ContactsMessage({
            text: "Удалено успешно",
            type: Constant.alertVariantSuccess,
          })
        );
        getData(Constant.defaultPageNumber, Constant.defaultPageSize, "");
        setShowDelete(false);
      } else {
        dispatch(
          setUser_ContactsMessage({
            text: "Ошибка!",
            type: Constant.alertVariantDanger,
          })
        );
      }
    }
  };

  const handleRowSelection = (row) => {
    console.log(row); // Row Selection Functionality can be written here
  };

  const handleAddButtonClick = () => {
    dispatch(
      setUser_ContactsMessage({ text: "", type: Constant.alertVariantSuccess })
    );
    hideShowForm("add");
  };

  const handleImportButtonClick = () => {
    dispatch(
      setUser_ContactsMessage({ text: "", type: Constant.alertVariantSuccess })
    );
    hideShowForm("import");
  };

  const { user } = useUser();

  let columns;

  if (user.is_admin === 1) {
    columns = [
      { name: "id", selector: (row) => row.id, sortable: true },
      {
        name: "ID пользователя",
        selector: (row) => row.user_id,
        sortable: true,
      },
      {
        name: "Имя пользователя",
        selector: (row) => row.user_id_value,
        sortable: true,
      },
      {
        name: "Номер телефона",
        selector: (row) => row.phone_number,
        sortable: true,
      },
      {
        name: "ID оператора",
        selector: (row) => row.operator_id,
        sortable: true,
      },
      {
        name: "Оператор",
        selector: (row) => row.operator_id_value,
        sortable: true,
      },
      {
        name: "ID рассылки",
        selector: (row) => row.company_id,
        sortable: true,
      },

      {
        name: "Дата создания",
        selector: (row) =>
          Intl.DateTimeFormat("ru-RU", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }).format(new Date(row.date_added)),
        sortable: true,
        minWidth: "165px",
      },
      {
        name: "Последние изменения",
        selector: (row) => row.last_updated_operator,
        sortable: true,
      },
      {
        name: "",
        button: true,
        cell: (row) => (
          <Button
            variant="link"
            className="btn-sm"
            onClick={() => handleRowEdit(row)}>
            Изменить
          </Button>
        ),
      },
      {
        name: "",
        button: true,
        cell: (row) => (
          <Button
            variant="link"
            className="btn-sm"
            onClick={() => handleRowDeleteClick(row)}>
            Удалить
          </Button>
        ),
      },
    ];
  } else {
    columns = [
      { name: "id", selector: (row) => row.id, sortable: true },
      {
        name: "Номер телефона",
        selector: (row) => row.phone_number,
        sortable: true,
      },
      {
        name: "Оператор",
        selector: (row) => row.operator_id_value,
        sortable: true,
      },
      {
        name: "Описание рассылки",
        selector: (row) => row.company_id_value,
        sortable: true,
      },
      {
        name: "Дата создания",
        selector: (row) =>
          Intl.DateTimeFormat("ru-RU", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
          }).format(new Date(row.date_added)),
        sortable: true,
        minWidth: "165px",
      },
      {
        name: "",
        button: true,
        cell: (row) => (
          <Button
            variant="link"
            className="btn-sm"
            onClick={() => handleRowEdit(row)}>
            Изменить
          </Button>
        ),
      },
      {
        name: "",
        button: true,
        cell: (row) => (
          <Button
            variant="link"
            className="btn-sm"
            onClick={() => handleRowDeleteClick(row)}>
            Удалить
          </Button>
        ),
      },
    ];
  }

  return (
    <Card className="shadow mb-4">
      <Card.Header className="py-3">
        <h6 className="m-0 font-weight-bold text-primary">
          Список контактов для рассылки ({rData.totalCount})
          <Button
            variant="light"
            className="btn-circle btn-sm ml-2"
            onClick={handleReset}>
            <i className="fa fa-refresh"></i>
          </Button>
          <Button
            className="btn-icon-split float-right mr-3"
            onClick={handleImportButtonClick}>
            <span className="icon text-white-50">
              <i className="fas fa-add"></i>
            </span>
            <span className="text">Импорт контактов</span>
          </Button>
        </h6>
      </Card.Header>
      <Card.Body>
        <Col
          className="ml-auto"
          md={3}
          xs={12}
          xl={3}>
          <InputGroup>
            <Form.Control
              placeholder="Поиск"
              aria-label="Search"
              aria-describedby="basic-search"
              onChange={(e) => setSearch(e.target.value)}
            />
            <Button
              disabled={search.length <= 2}
              variant="dark"
              className="rounded-0 rounded-right"
              id="button-search"
              onClick={handleSearch}>
              Поиск
            </Button>
          </InputGroup>
        </Col>
        <div className="table-responsive">
          <DataTable
            noDataComponent="Нет записей для отображения"
            selectableRows={true}
            onSelectedRowsChange={handleRowSelection}
            paginationPerPage={Constant.defaultPageSize}
            paginationRowsPerPageOptions={Constant.paginationRowsPerPageOptions}
            columns={columns}
            data={rData.list}
            onChangeRowsPerPage={handlePerRowsChange}
            paginationTotalRows={rData.totalCount}
            className="table table-bordered"
            pagination
            paginationServer
            onChangePage={handlePageChange}></DataTable>
        </div>
      </Card.Body>
      <ConfirmationModal
        buttonNegative=" Отменить"
        buttonPositive="Удалить"
        title="Подтверждение удаления"
        show={showDelete}
        body={"Вы уверены?"}
        onNegative={() => setShowDelete(false)}
        onPositive={handleServerDelete}
      />
    </Card>
  );
};
